import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { defaultBagConditionsOptions, getConditionsFilterConfig } from '../filters/condition';
import { BuilderSections } from '../../util/builder';

export const baboontothemoonShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: defaultBagConditionsOptions }),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: 'c0458e5775d046e794e9a574b33904dd',
    },
  },
};
